import React, { useEffect, useState } from "react";
import editicon from "../../Images/editicon.png";
import cameralogo from "../../Images/cameralogo.png";
import Editbannermodalbml from "../../Modal/Editbannermodalbml";
import { useSelector } from "react-redux";

const Uploadbannerblm = ({ data, updateForm, setIsUpdate }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [bannermodalaedi, setBannermodalaedi] = useState(false);
  const [url, setUrl] = useState(data?.businesBanner || "");

  const editbannermodalclick = () => {
    setBannermodalaedi(!bannermodalaedi);
  };

  useEffect(() => {
    setUrl(data?.businesBanner)
  }, [data])

  return (
    <>
      <div className="uploadbannerblmdiv ">
        <div className="uploadbannerdivbg">
          {
            UserProfileID?._id === data?._id &&
            <div className="editeiconimgspclnmew">
              <img src={editicon} alt="..." onClick={editbannermodalclick} />
            </div>
          }


          <div className="cameralogodivimgabslt" style={{
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            minWidth: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0px'
          }}>

            {data?.businesBanner ? (
              <div className="cameralogodivimg" style={{
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                minWidth: '100%',
              }}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                  src={data?.businesBanner}
                  alt="..."
                />
              </div>
            ) : (
              <>
                <div>
                  <div className="cameralogodivimg">
                    <img src={cameralogo} alt="..." />
                  </div>
                  <p className="uplsdttxttppshji">Upload Banner</p>
                  <p className="pixelsttxttppio">
                    (Pixel Size : 942 x 283 PNG/JPEG )
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {bannermodalaedi && (
        <Editbannermodalbml
          url={url || data?.businesBanner}
          setUrl={setUrl}
          updateForm={updateForm}
          closemodal={setBannermodalaedi}
          setIsUpdate={setIsUpdate}
        />
      )}
    </>
  );
};

export default Uploadbannerblm;
